import BaseController from "confinus_ui/base_controller";
import { DataTableController } from "decor";
import { DecorSuiteTablesDataTableIdentifier } from "decor";

// Local alias for readability; same value as the imported canonical identifier.
const DataTableOutletId = DecorSuiteTablesDataTableIdentifier;

export default class RouteFormController extends BaseController {
  public static targets = [
    "templateRow",
    "stateFields",
    "cityFields",
    "polygonFields",
  ];
  declare private readonly templateRowTarget: HTMLDivElement;
  declare private readonly stateFieldsTarget?: HTMLDivElement;
  declare private readonly cityFieldsTarget?: HTMLDivElement;
  declare private readonly polygonFieldsTarget?: HTMLDivElement;
  declare private readonly hasStateFieldsTarget: boolean;
  declare private readonly hasCityFieldsTarget: boolean;
  declare private readonly hasPolygonFieldsTarget: boolean;

  public static outlets = [DataTableOutletId];
  // Generated outlet accessor: camelCase of identifier with double-dash stripped.
  declare private readonly decorSuiteTablesDataTableOutlet: DataTableController;
  private get tableController() {
    return this.decorSuiteTablesDataTableOutlet;
  }

  connect(): void {
    console.log("RouteFormController connected");
    console.log("Has state fields target:", this.hasStateFieldsTarget);
    console.log("Has city fields target:", this.hasCityFieldsTarget);
    console.log("Has polygon fields target:", this.hasPolygonFieldsTarget);

    // Set initial visibility based on current selection
    const regionTypeSelect = this.element.querySelector<HTMLSelectElement>(
      '[name*="region_type"]',
    );
    console.log("Found region type select:", regionTypeSelect);
    if (regionTypeSelect) {
      console.log("Initial region type value:", regionTypeSelect.value);
      this.updateFieldVisibility(regionTypeSelect.value);
    }
  }
  addDay(event: Event) {
    event.preventDefault();

    // Get the hidden row (the template)
    const template = this.templateRowTarget as HTMLElement;

    // Clone the template content
    const clone = document.importNode(template, true);

    // Remove the hidden class from the clone
    clone.classList.remove("hidden");

    // Append the clone to the tbody
    this.tableController.appendRow(clone);
  }

  removeDay(event: Event) {
    event.preventDefault();

    // Get the clicked element
    const target = event.target as HTMLElement;

    // Find the closest row to the clicked element
    const row = target.closest("tr");

    // If a row was found, remove it
    if (row) {
      row.remove();
    }
  }

  regionTypeChanged(event: Event) {
    console.log("regionTypeChanged called");
    const select = event.target as HTMLSelectElement;
    console.log("Selected value:", select.value);
    this.updateFieldVisibility(select.value);
  }

  private updateFieldVisibility(regionType: string): void {
    console.log("updateFieldVisibility called with:", regionType);

    // Hide all conditional fields first
    if (this.hasStateFieldsTarget && this.stateFieldsTarget) {
      console.log("Hiding state fields");
      this.stateFieldsTarget.classList.add("hidden");
    }
    if (this.hasCityFieldsTarget && this.cityFieldsTarget) {
      console.log("Hiding city fields");
      this.cityFieldsTarget.classList.add("hidden");
    }
    if (this.hasPolygonFieldsTarget && this.polygonFieldsTarget) {
      console.log("Hiding polygon fields");
      this.polygonFieldsTarget.classList.add("hidden");
    }

    // Show relevant fields based on selection
    if (regionType === "state" || regionType === "city") {
      if (this.hasStateFieldsTarget && this.stateFieldsTarget) {
        console.log("Showing state fields");
        this.stateFieldsTarget.classList.remove("hidden");
      }
    }
    if (regionType === "city") {
      if (this.hasCityFieldsTarget && this.cityFieldsTarget) {
        console.log("Showing city fields");
        this.cityFieldsTarget.classList.remove("hidden");
      }
    }
    if (regionType === "polygon") {
      if (this.hasPolygonFieldsTarget && this.polygonFieldsTarget) {
        console.log("Showing polygon fields");
        this.polygonFieldsTarget.classList.remove("hidden");
      }
    }
  }
}
